<ng-container *ngIf="auth.isAuthenticated$ | async; else loggedOut">
</ng-container>
<ng-template #loggedOut>
  <kendo-card>

    <kendo-card-header>

      <img src="assets/img/badge_sercom.png"/>


      <h1 kendoCardTitle>
        Monitor Program
      </h1>
      <p kendoCardSubtitle>Authorisation</p>
    </kendo-card-header>
    <kendo-card-body>

      <button kendoButton icon="login" [primary]="true" (click)="auth.loginWithRedirect()">Log in</button>
    </kendo-card-body>

  </kendo-card>
</ng-template>
